import '../scss/theme.scss'

const trimResponsiveBreakWhitespace = () => {
	const targetElements = new Set(
		[...document.querySelectorAll('br.is-sp, br.is-tb, br.is-pc')]
			.map((breakElement) => breakElement.parentElement)
			.filter(Boolean)
	)

	targetElements.forEach((element) => {
		element.childNodes.forEach((node) => {
			if (node.nodeType !== Node.TEXT_NODE || !node.nodeValue) return

			const trimmedValue = node.nodeValue.replace(/^\s+|\s+$/g, '')

			if (trimmedValue) {
				node.nodeValue = trimmedValue
			} else {
				node.remove()
			}
		})
	})
}

const initTheme = () => {
	trimResponsiveBreakWhitespace()
	initPartnershopTracking()
}

const initPartnershopTracking = () => {
 const storageKey = 'motto-totonou:partnershop'
 const duration = 30 * 24 * 60 * 60 * 1000
 const parameterKeys = ['partnershop', 'partnershop_id', 'partnershop-id']
 const params = new URLSearchParams(window.location.search)
 let memory = null
 let expiryTimer
 let pending = null
 let allowSubmit = false
 const normalize = value => /^[A-Z0-9]{7}$/.test(String(value || '').trim().toUpperCase()) ? String(value).trim().toUpperCase() : ''
 const save = value => {
  memory = value
  try {
   if (value) localStorage.setItem(storageKey, JSON.stringify(value))
   else localStorage.removeItem(storageKey)
  } catch { /* 保存できない環境では現在のタブ内だけで保持する。 */ }
 }
 const read = () => {
  try { memory = JSON.parse(localStorage.getItem(storageKey) || 'null') } catch { /* タブ内の値を利用する。 */ }
  if (!memory || !normalize(memory.id) || !Number.isSafeInteger(memory.expiresAt) || memory.expiresAt <= Date.now() || memory.expiresAt > Date.now() + duration) {
   save(null)
   return null
  }
  return {id:normalize(memory.id),expiresAt:memory.expiresAt}
 }
 const key = value => value ? `${value.id}:${value.expiresAt}` : ''
 const attributes = value => ({partnershop_id:value?.id || '',partnershop_expires_at:value ? String(value.expiresAt) : ''})
 const updateLinks = value => {
  document.querySelectorAll('a.buy-now-button[href*="/cart/"]').forEach(link => {
   const url = new URL(link.href,location.origin)
   if (url.origin !== location.origin) return
   url.searchParams.delete('checkout')
   for (const [name,content] of Object.entries(attributes(value))) {
    if (content) url.searchParams.set(`attributes[${name}]`,content)
    else url.searchParams.delete(`attributes[${name}]`)
   }
   link.href = `${url.pathname}${url.search}${url.hash}`
  })
 }
 const sync = async () => {
  // Web Locks対応ブラウザでは、複数タブからのカート更新も直列にする。
  const work = async () => {
   for (let attempt=0; attempt<4; attempt++) {
    const value=read()
    updateLinks(value)
    try {
     const response=await fetch(`${window.routes?.cart_url || '/cart'}.js`,{headers:{Accept:'application/json'},cache:'no-store',signal:AbortSignal.timeout(8000)})
     if (!response.ok) throw new Error('カート取得失敗')
     const cart=await response.json()
     if (key(value)!==key(read())) continue
     const wanted=attributes(value)
     if (Object.entries(wanted).some(([name,content])=>String(cart.attributes?.[name] || '')!==content)) {
      const update=await fetch(`${window.routes?.cart_update_url || '/cart/update'}.js`,{method:'POST',headers:{Accept:'application/json','Content-Type':'application/json'},body:JSON.stringify({attributes:wanted}),signal:AbortSignal.timeout(8000)})
      if (!update.ok) throw new Error('カート更新失敗')
      const saved=await update.json()
      if (Object.entries(wanted).some(([name,content])=>String(saved.attributes?.[name] || '')!==content)) throw new Error('カート更新未完了')
     }
     if (key(value)!==key(read())) continue
     return true
    } catch {
     if (attempt<3) await new Promise(resolve=>setTimeout(resolve,500*2**attempt))
    }
   }
   return false
  }
  if (!pending) pending=(navigator.locks ? navigator.locks.request('totonou-partner-cart',work) : work()).finally(()=>{pending=null})
  return pending
 }
 const refresh = () => {
  const value=read()
  updateLinks(value)
  clearTimeout(expiryTimer)
  if(value) expiryTimer=setTimeout(refresh,Math.min(2147483647,Math.max(1,value.expiresAt-Date.now())))
  void sync()
 }
 if(params.get('partnershop_reset')==='1') save(null)
 else {
  const requested=parameterKeys.map(name=>normalize(params.get(name))).find(Boolean)
  if(requested) save({id:requested,expiresAt:Date.now()+duration})
 }
 // 再表示時に購入前のURLから帰属が復活しないよう、処理済みの専用パラメータを除く。
 if(parameterKeys.some(name=>params.has(name)) || params.has('partnershop_reset')) {
  for(const name of [...parameterKeys,'partnershop_reset']) params.delete(name)
  history.replaceState(history.state,'',`${location.pathname}${params.size?'?'+params:''}${location.hash}`)
 }
 window.addEventListener('storage',event=>{if(event.key===storageKey || event.key===null) refresh()})
 for(const event of ['pageshow','focus','online']) window.addEventListener(event,refresh)
 document.addEventListener('visibilitychange',()=>{if(document.visibilityState==='visible') refresh()})
 document.addEventListener('click',async event=>{
  const link=event.target.closest?.('a.buy-now-button[href*="/cart/"]')
  if(!link || event.button!==0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return
  event.preventDefault()
  if(await sync()) { updateLinks(read()); location.assign(link.href) }
  else window.alert('購入情報を更新できませんでした。通信状態を確認して、もう一度お試しください。')
 },true)
 document.addEventListener('submit',async event=>{
  if(allowSubmit || !(event.target instanceof HTMLFormElement) || event.submitter?.name!=='checkout') return
  event.preventDefault()
  if(await sync()) { allowSubmit=true; event.target.requestSubmit(event.submitter); allowSubmit=false }
  else window.alert('購入情報を更新できませんでした。通信状態を確認して、もう一度お試しください。')
 },true)
 refresh()
}

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', initTheme)
} else {
	initTheme()
}
